<template>
  <div class="realFooter">
    <div class="footer" v-show="isshow">
      <div class="footUl clearfix">
        <ul class="foot_Product">
          <li class="foot_title">产品与服务</li>
          <li @click="toRecruitList">翻译项目</li>
          <li @click="toOpenRenwu">快速任务</li>
          <!-- <li @click="toCatIntro">辅助翻译</li> -->
        </ul>
        <ul class="foot_Solution">
          <li class="foot_title">服务指南</li>
          <!-- <li @click="toRuleManagement">服务规则</li> -->
          <li @click="toServiceAgreement">服务协议</li>
          <li @click="toLegalPrivacy">隐私政策</li>
          <li @click="toHelpCenter">帮助中心</li>
          <!-- <li @click="toPlatformRules">平台规则</li> -->
        </ul>
        <ul class="foot_Solution">
          <li class="foot_title">公司</li>
          <li @click="toAbout">关于我们</li>
          <li @click="toYY">成为译员</li>
        </ul>
        <!-- <ul class="foot_MoreF">
            <li class="foot_title">更多服务</li>
            <li>在线人工翻译</li>
            <li>海外招标信息服务平台</li>
            <li>辅助翻译平台</li>
          </ul>-->
        <ul class="foot_About">
          <li class="foot_title">联系我们</li>
          <li>合作邮箱：cipgtranslator@cipgtrans.com</li>
          <li class="address clearfix">
            <span>地址：</span>
            <span>北京市海淀区车公庄西路甲19号国际传播大厦七层</span>
          </li>
          <li class="footBtn" @click="toContactUs">联系我们</li>
        </ul>
      </div>
      <p style="color: #666; font-size: 12px">v3.5.2</p>
      <div class="footCen">
        <p>
          <span>友情链接：</span>
          <a href="http://www.cipg.org.cn/" target="_blank"
            >中国外文出版发行事业局</a
          >
          <a href="http://www.tac-online.org.cn/" target="_blank"
            >中国翻译协会</a
          >
          <a href="http://www.nwp.com.cn" target="_blank">新世界出版社</a>
          <a href="http://www.ctis-cn.com/" target="_blank"
            >北京中外翻译咨询有限公司</a
          >
        </p>
        <p>
          Copyright © 2021 开翻
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
            >京ICP备16008517号-1</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "realFooter",
  data() {
    return {
      userId: null,
      isshow: false,
    };
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.userId = this.$cookie.get("uid");
    // this.$cookie.get("uid")
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    setTimeout(() => {
      this.isshow = true;
    }, 300);
  },
  // 方法集合
  methods: {
    toYY() {
      this.$router.push("/contract");
    },
    toAuthenticationState() {
      window.scrollTo(0, 0);
      this.$router.push("/authenticationState");
    },
    toOpenRenwu() {
      if (this.userId) {
        this.$router.push("/taskHall");
      } else {
        this.$message.warning("请登录后查看更多信息！");
        this.$router.push("/login");
      }
    },
    toContactUs() {
      window.scrollTo(0, 0);
      this.$router.push("/contactUs");
    },
    toCatIntro() {
      // window.scrollTo(0, 0);
      // this.$router.push("/catIntro");
    },
    toAbout() {
      window.scrollTo(0, 0);
      this.$router.push("/about");
    },
    toRecruitList() {
      window.scrollTo(0, 0);
      this.$router.push("/recruitList");
    },
    toRuleManagement() {
      let routeUrl = this.$router.resolve({ path: "/ruleManagement" });
      window.open(routeUrl.href, "_blank");
    },
    toServiceAgreement() {
      let routeUrl = this.$router.resolve({ path: "/serviceAgreement" });
      window.open(routeUrl.href, "_blank");
    },
    toLegalPrivacy() {
      let routeUrl = this.$router.resolve({ path: "/legalPrivacy" });
      window.open(routeUrl.href, "_blank");
    },
    toHelpCenter() {
      let routeUrl = this.$router.resolve({ path: "/registerAndLogin" });
      window.open(routeUrl.href, "_blank");
    },
    toPlatformRules() {
      let routeUrl = this.$router.resolve({ path: "/punishmentStandard" });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style scoped>
.realFooter {
  width: 100%;
  min-width: 1200px;
  background: #21283a;
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.footer {
  width: 980px;
  margin: 0 auto;
  text-align: left;
  color: #fff;
}
.footUl {
  height: 252px;
  padding-top: 20px;
  padding-bottom: 40px;
}
.footUl ul {
  float: left;
  width: 150px;
  margin-right: 40px;
}
ul.foot_About {
  float: right;
  width: 280px;
  margin-right: 0;
}
.footUl ul .foot_title {
  height: 58px;
  line-height: 58px;
  opacity: 0.8 !important;
  font-size: 16px;
  cursor: unset;
}
.footUl ul li {
  font-size: 12px;
  opacity: 0.5;
  line-height: 30px;
}
.foot_Product li,
.foot_Solution li {
  cursor: pointer;
}
.footUl .foot_Product li:hover,
.footUl .foot_Solution li:hover {
  opacity: 1;
}
.footUl ul li a {
  color: #fff;
}
.address span {
  /* padding-top: 4px; */
  display: block;
  float: left;
  /* line-height: 16px; */
}
.address span:first-of-type {
  width: 38px;
}
.address span:last-of-type {
  width: 182px;
}
.footBtn {
  margin-top: 10px;
  width: 120px;
  height: 34px;
  line-height: 32px;
  text-align: center;
  border: 1px solid #fff;
  cursor: pointer;
}
.footBtn:hover {
  opacity: 0.8;
}
.footCen {
  text-align: center;
  border-top: 1px solid #fff;
  padding-top: 8px;
  padding-bottom: 30px;
  line-height: 34px;
  color: #fff;
  font-size: 14px;
  opacity: 0.4;
}
.footCen a {
  color: #fff;
  margin-left: 24px;
}
</style>
